<template>
  <v-container fill-height justify-content-start class="app-section-width pa-0">
    <v-layout column>
      <v-layout
        flat
        class="activity-header red lighten-1"
      >
        <v-layout row align-center class="px-4">
          <v-icon color="white" class="ms-3 me-3 display-1">mdi-alert</v-icon>
          <v-toolbar-title class="white--text">
            {{ $t('activity_reservation.error.error') }}
          </v-toolbar-title>
        </v-layout>
      </v-layout>
      <v-flex class="app-scroll-section px-4 py-5">
        <span v-if="getCapacityStatus({ over: true })" class="display-1">
          {{ $t("activity_reservation.over_capacity") }}
        </span>
        <span v-else-if="errorString">
          <span class="display-1">
            {{ errorString }}
          </span>
        </span>
        <v-layout v-else column>
          <span class="display-1">
            {{ $t('activity_reservation.error.generic_error_1') }}
          </span>
          <span class="body-1 mt-3">
            {{ $t('activity_reservation.error.generic_error_2') }}
          </span>
        </v-layout>
        <v-btn
          x-large
          @click="() => {
            reservationMethodType === 'IN_VENUE'
            ? $router.go(-2)
            : $router.go(smAndDown ? -3 : -2)
          }"
          outlined
          block
          color="primary"
          class="primary-gradient mt-10"
        >
          {{ $t('activity_reservation.error.back') }}
        </v-btn>
        <v-btn
          x-large
          @click="retryReservation()"
          outlined
          :loading="pendingConfirmation"
          block
          color="primary"
          class="primary-gradient mt-5"
        >
          {{ $t('activity_reservation.error.retry') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import routeNames from '@/router/routes'
import reservationMixin from '@/mixins/Reservation'
import activityMixins from '@/mixins/Activity'
import vuetifyMixins from '@/mixins/Vuetify'

export default {
  beforeMount () {
    if (!this.state.error) {
      this.$router.go(-1)
    }
  },
  data () {
    return {
      routeNames,
      pendingConfirmation: false,
    }
  },
  computed: {
    ...mapGetters({
      getDashboardName: 'service/getDashboardName',
      getOrder: 'cart/getOrder',
    }),
    ...mapState(['activityReservations', 'state']),
    errorString () {
      let errorString
      const errors = this.state.error.body
      if (Array.isArray(errors)) {
        if (errors.some(e => e.error_code === 'NOT_ENOUGH_BALANCE')) {
          errorString = this.$t('error.not_enough_balance')
        } else if (errors.some(e => e.error_code === 'DISABLED_ACCOUNT')) {
          errorString = this.$t('error.disabled_account')
        } else if (errors.some(e => e.error_code === 'DISABLED_GUEST')) {
          errorString = this.$t('error.disabled_guest')
        } else if (errors.some(e => e.error_code === 'LIMIT_EXCEEDED')) {
          errorString = this.$t('error.limit_exceded')
        } else if (errors.some(e => ['ILLEGAL_RELATED_TRANSACTIONS', 'MIXED_TRANSACTION_TYPES', 'MULTIPLE_ACCOUNTS_WITH_PAYMENT_GATEWAYS', 'MULTIPLE_PAYMENT_GATEWAYS_FOR_SAME_ACCOUNT', 'MULTIPLE_PAYMENT_GATEWAYS_ON_RELATED_TRANSACTIONS', 'PAYMENT_GATEWAY_COMMUNICATION_ERROR', 'TRANSACTION_ALREADY_EXISTS'].includes(e.error_code))) { // TODO
          errorString = this.$t('error.payment_error')
        }
      }
      return errorString
    },
  },
  methods: {
    retryReservation () {
      this.getSlotCapacity()
        .then(() => {
          if (this.getCapacityStatus({ over: true })) return
          this.pendingConfirmation = true
          this.$store
            .dispatch('activityReservations/retryReservation')
            .then(() => {
              this.$router.push({ name: routeNames.reservationComplete.name })
            })
            .catch((error) => {
              this.$store.commit('state/setError', error)
            })
            .finally(() => {
              this.pendingConfirmation = false
            })
        })
    },
  },
  async created () {
    // Refresh account data
    await this.$store.dispatch('me/getBookings')
    this.$store.dispatch('accounts/listMyAccounts').then((accounts) => {
      const accountId = this.activityReservations.edited.account.id
      this.$store.commit('activityReservations/setField', { field: 'account', value: accounts.find(account => account.id === accountId) })
    })
  },
  mixins: [
    reservationMixin,
    activityMixins,
    vuetifyMixins,
  ],
}
</script>

<style scoped lang="scss">
.notranslate {
  transform: none !important;
}
.section-width {
  max-width: 800px !important;
}
.activity-header {
  max-height: 90px;
}
</style>
